export default "/JMMMU/world_history.5301c432-5e05a1.jpg";